'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".CsrSignInForm-module_formWrapper__wzcfV{display:flex;flex-direction:column;gap:1rem;max-width:420px;padding:2rem 1.5rem;text-align:left}.CsrSignInForm-module_form__ikqAi{display:flex;flex-direction:column;gap:14px;text-align:left}.CsrSignInForm-module_textInput__T4OUs{height:45px}";
var styles = {"formWrapper":"CsrSignInForm-module_formWrapper__wzcfV","form":"CsrSignInForm-module_form__ikqAi","textInput":"CsrSignInForm-module_textInput__T4OUs"};
styleInject["default"](css_248z, '4650ad35-6bbc-4395-960a-cb3a778c46f6');

exports["default"] = styles;
